import { render } from "./AddServiceModal.vue?vue&type=template&id=229da0a7&ts=true"
import script from "./AddServiceModal.vue?vue&type=script&lang=ts"
export * from "./AddServiceModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__